"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSessionId = void 0;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
const useGetSessionId = (apiClient, tenant) => {
  const subscriptionId = (0, _presentationUtils.getClientQueryParam)('subscriptionId');
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [sessionId, setSessionId] = (0, _react.useState)(undefined);
  if (!sessionId && !isLoading && subscriptionId) {
    setIsLoading(true);
    void (0, _globalApiClientReact.createPersonalSubscriptionShoppingSession)(apiClient, Number(subscriptionId), {
      [_fetching.TENANT_CONTEXT]: tenant
    }).then(response => {
      if (response.status === 200) {
        setSessionId(response.data.sessionId);
        setIsLoading(false);
      }
    });
  }
  return {
    isLoading,
    sessionId,
    subscriptionId
  };
};
exports.useGetSessionId = useGetSessionId;